import * as React from 'react';
import { ERoomType } from '../../../../types/rooms';
import { CheckboxButton } from '@cian/ui-kit';
import * as style from './style.css';
import { jsx as _jsx } from "react/jsx-runtime";
/** Типы комнатностей, отсутствующие в карточках жк **/
const ADDITIONAL_ROOM_TYPES = [ERoomType.FiveRoom, ERoomType.Large, ERoomType.OpenPlan];

// eslint-disable-next-line react/display-name
export const RoomTypeFilter = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    roomsCountList,
    value,
    onChange
  } = _ref;
  const onClick = React.useCallback(currentValue => () => {
    const index = value.indexOf(currentValue);
    let result = [...value];
    if (index === -1) {
      result.push(currentValue);
      if (currentValue === ERoomType.FourRoom) {
        result = [...result, ...ADDITIONAL_ROOM_TYPES];
      }
    } else {
      result.splice(index, 1);
      if (currentValue === ERoomType.FourRoom) {
        result = result.filter(val => !ADDITIONAL_ROOM_TYPES.includes(val));
      }
    }
    onChange(result);
  }, [onChange, value]);
  return /*#__PURE__*/_jsx("div", {
    className: style['container'],
    ref: ref,
    children: roomsCountList.map(room => /*#__PURE__*/_jsx(CheckboxButton, {
      disabled: !room.isAvailable,
      label: room.roomTitle,
      checked: value.includes(room.roomValue),
      onChange: onClick(room.roomValue)
    }, room.roomValue))
  });
});